import GraphQL from './GraphQL'

class ManagerOrdersClass {
    constructor() {
        this.url = '/personal/order/make/'
    }

    getList(cb, PAGE=null, PER_PAGE=null, fields={
        orders : {
            ID : null,
            STATUS_ID : null,
            STATUS : {
                ID : null,
                STATUS_ID : null,
                COLOR : null,
                NAME : null,
                DESCRIPTION : null
            },
            ACCOUNT_NUMBER : null,
            TRACKING_NUMBER : null,
            PAY_SYSTEM_ID: null,
            PAYMENT : {
                ID : null, 
                NAME : null,
                ACTIVE : null, 
                CODE : null, 
                SORT : null,
                PSA_NAME : null,
                DESCRIPTION : null,
                LOGOTIP : null,
            },
            DELIVERY_ID : null,
            DELIVERY : {
                ID : null, 
                NAME : null,
                ACTIVE : null, 
                CODE : null, 
                SORT : null,
                CURRENCY : null,
                DESCRIPTION : null,
                LOGOTIP : null,
                PRICE : null,
                PERIOD_FROM : null,
                PERIOD_TO : null,
                PERIOD_TYPE : null,
                PICKUP : null
            },
            PRICE_DELIVERY : null,
            PERSON_TYPE_ID : null,
            USER_ID : null,
            PAYED : null,
            STORE_ID : null,
            STORE : {
                ID : null,
                TITLE : null,
                ACTIVE : null,
                ADDRESS : null,
                DESCRIPTION : null,
                GPS_N : null,
                GPS_S : null,
                PHONE : null,
                SCHEDULE : null,
                SORT : null,
                EMAIL : null,
                ISSUING_CENTER : null,
                SHIPPING_CENTER : null,
                CODE : null,
            },
            PRICE : null,
            CURRENCY : null,
            DISCOUNT_VALUE : null,
            SUM_PAID : null,
            USER_DESCRIPTION : null,
            LOCKED_BY : null,
            LOCK_USER_NAME : null,
            XML_ID : null,
            CANCELED : null,
            REASON_CANCELED : null,
            UPDATED_1C : null,
            PERSON : {
                ID : null, 
                NAME : null
            },
            DATE_INSERT : {
                timestamp : null,
                timezone : null,
                ISO : null
            },
            DATE_UPDATE : {
                timestamp : null,
                timezone : null,
                ISO : null
            },
            DATE_CANCELED : {
                timestamp : null,
                timezone : null,
                ISO : null
            },
            DATE_LOCK : {
                timestamp : null,
                timezone : null,
                ISO : null
            },
            ID_1C : null,
            PROPERTIES : {
                ID : null,
                ORDER_ID : null,
                ORDER_PROPS_ID : null,
                NAME : null,
                VALUE : null,
                CODE : null,
                XML_ID : null,
                ENTITY_ID : null,
                ENTITY_TYPE : null,
            },
            CART : {
                count : null, 
                count_format : null, 
                summary : null, 
                summary_format : null, 
                summary_base : null, 
                summary_base_format : null, 
                discount_summary : null, 
                discount_summary_format : null, 
                coupons : null, 
                items : {
                    ID : null, 
                    PRODUCT_ID : null, 
                    DETAIL_PAGE_URL : null, 
                    NAME : null, 
                    WEIGHT : null, 
                    WEIGHT_FORMAT : null, 
                    DISCOUNT_SUMMARY_PRICE : null, 
                    DISCOUNT_SUMMARY_PRICE_FORMAT : null, 
                    PRICE : null, 
                    PRICE_FORMAT : null, 
                    SUMMARY : null, 
                    SUMMARY_FORMAT : null, 
                    BASE_PRICE : null, 
                    BASE_PRICE_FORMAT : null, 
                    BASE_PRICE_SUMMARY : null, 
                    BASE_PRICE_SUMMARY_FORMAT : null, 
                    DISCOUNT_PERCENT : null, 
                    DISCOUNT_PRICE : null, 
                    DISCOUNT_PRICE_FORMAT : null, 
                    QUANTITY : null, 
                    OLD_QUANTITY : null, 
                    AMOUNT : null, 
                    CAN_BUY : null, 
                    IS_DELAY : null, 
                    CURRENCY : null, 
                    PREVIEW_PICTURE : null
                }
            }
        },
        properties : {
            ID : null, 
            NAME : null,
            PERSON_TYPE_ID : null,
            CODE : null, 
            SORT : null,
            PROPERTIES : {
                ID : null, 
                NAME : null,
                TYPE : null,
                PROPS_GROUP_ID : null, 
                PERSON_TYPE_ID : null,
                IS_ADDRESS : null,
                IS_PHONE : null, 
                IS_ZIP : null,
                ACTIVE : null, 
                REQUIRED : null, 
                CODE : null, 
                SORT : null,
                DESCRIPTION : null,
                DEFAULT_VALUE : null,
            },
        },
        pagination : null,
    }) {
        GraphQL.query('manager_list', {
            'PAGE : Int' : PAGE,
            'PER_PAGE : Int' : PER_PAGE,
        }, fields, cb)
    }

    getOrder(cb, ORDER_ID=null, fields={
        order : {
            ID : null,
            STATUS_ID : null,
            STATUS : {
                ID : null,
                STATUS_ID : null,
                COLOR : null,
                NAME : null,
                DESCRIPTION : null
            },
            ACCOUNT_NUMBER : null,
            TRACKING_NUMBER : null,
            PAY_SYSTEM_ID: null,
            PAYMENT : {
                ID : null, 
                NAME : null,
                ACTIVE : null, 
                CODE : null, 
                SORT : null,
                PSA_NAME : null,
                DESCRIPTION : null,
                LOGOTIP : null,
            },
            DELIVERY_ID : null,
            DELIVERY : {
                ID : null, 
                NAME : null,
                ACTIVE : null, 
                CODE : null, 
                SORT : null,
                CURRENCY : null,
                DESCRIPTION : null,
                LOGOTIP : null,
                PRICE : null,
                PERIOD_FROM : null,
                PERIOD_TO : null,
                PERIOD_TYPE : null,
                PICKUP : null
            },
            PRICE_DELIVERY : null,
            PERSON_TYPE_ID : null,
            USER_ID : null,
            PAYED : null,
            STORE_ID : null,
            STORE : {
                ID : null,
                TITLE : null,
                ACTIVE : null,
                ADDRESS : null,
                DESCRIPTION : null,
                GPS_N : null,
                GPS_S : null,
                PHONE : null,
                SCHEDULE : null,
                SORT : null,
                EMAIL : null,
                ISSUING_CENTER : null,
                SHIPPING_CENTER : null,
                CODE : null,
            },
            PRICE : null,
            CURRENCY : null,
            DISCOUNT_VALUE : null,
            SUM_PAID : null,
            USER_DESCRIPTION : null,
            LOCKED_BY : null,
            LOCK_USER_NAME : null,
            XML_ID : null,
            CANCELED : null,
            REASON_CANCELED : null,
            UPDATED_1C : null,
            PERSON : {
                ID : null, 
                NAME : null
            },
            DATE_INSERT : {
                timestamp : null,
                timezone : null,
                ISO : null
            },
            DATE_UPDATE : {
                timestamp : null,
                timezone : null,
                ISO : null
            },
            DATE_CANCELED : {
                timestamp : null,
                timezone : null,
                ISO : null
            },
            DATE_LOCK : {
                timestamp : null,
                timezone : null,
                ISO : null
            },
            ID_1C : null,
            PROPERTIES : {
                ID : null,
                ORDER_ID : null,
                ORDER_PROPS_ID : null,
                NAME : null,
                VALUE : null,
                CODE : null,
                XML_ID : null,
                ENTITY_ID : null,
                ENTITY_TYPE : null,
            },
            CART : {
                count : null, 
                count_format : null, 
                summary : null, 
                summary_format : null, 
                summary_base : null, 
                summary_base_format : null, 
                discount_summary : null, 
                discount_summary_format : null, 
                coupons : null, 
                items : {
                    ID : null, 
                    PRODUCT_ID : null, 
                    DETAIL_PAGE_URL : null, 
                    NAME : null, 
                    WEIGHT : null, 
                    WEIGHT_FORMAT : null, 
                    DISCOUNT_SUMMARY_PRICE : null, 
                    DISCOUNT_SUMMARY_PRICE_FORMAT : null, 
                    PRICE : null, 
                    PRICE_FORMAT : null, 
                    SUMMARY : null, 
                    SUMMARY_FORMAT : null, 
                    BASE_PRICE : null, 
                    BASE_PRICE_FORMAT : null, 
                    BASE_PRICE_SUMMARY : null, 
                    BASE_PRICE_SUMMARY_FORMAT : null, 
                    DISCOUNT_PERCENT : null, 
                    DISCOUNT_PRICE : null, 
                    DISCOUNT_PRICE_FORMAT : null, 
                    QUANTITY : null, 
                    OLD_QUANTITY : null, 
                    AMOUNT : null, 
                    CAN_BUY : null, 
                    IS_DELAY : null, 
                    CURRENCY : null, 
                    PREVIEW_PICTURE : null
                }
            }
        },
        properties : {
            ID : null, 
            NAME : null,
            PERSON_TYPE_ID : null,
            CODE : null, 
            SORT : null,
            PROPERTIES : {
                ID : null, 
                NAME : null,
                TYPE : null,
                PROPS_GROUP_ID : null, 
                PERSON_TYPE_ID : null,
                IS_ADDRESS : null,
                IS_PHONE : null, 
                IS_ZIP : null,
                ACTIVE : null, 
                REQUIRED : null, 
                CODE : null, 
                SORT : null,
                DESCRIPTION : null,
                DEFAULT_VALUE : null,
            },
        },
        statuses : {
            ID : null,
            STATUS_ID : null,
            COLOR : null,
            NAME : null,
            DESCRIPTION : null
        }
    }) {
        GraphQL.query('manager_order', {
            'ORDER_ID : Int!' : ORDER_ID
        }, fields, cb)
    }
}

const ManagerOrders = new ManagerOrdersClass()

export default ManagerOrders